import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/prismatic-logo.svg")